export default __webpack_public_path__ + "static/media/mirror.7821f8e7.png";